import {
  FETCH_SOURCES_START,
  FETCH_SOURCES_SUCCESS,
  FETCH_SOURCES_FAIL,
} from '../actions/actionTypes.js'

const INITIAL_STATE = {
  sources: [],
  isFetching: true,
  errorMessage: '',
}

const sourcesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SOURCES_START:
      return {
        ...state,
        isFetching: true,
        errorMessage: '',
      }
    case FETCH_SOURCES_SUCCESS:
      return {
        ...state,
        sources: action.payload,
        isFetching: false,
        errorMessage: '',
      }
    case FETCH_SOURCES_FAIL:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload,
      }
    default:
      return state
  }
}

export default sourcesReducer
